import { TableCellProps } from '@mui/material';
import { StyledTableCell } from './CustomTableCell.styles';

const CustomTableCellComponent = function ({ children, ...props }: TableCellProps): JSX.Element {
  return <StyledTableCell {...props}>{children}</StyledTableCell>;
};

export default CustomTableCellComponent;
